import type { ReactNode } from 'react';

/** One block on an extension's tab: devices, tokens, the download. A plain
 *  border, not a raised card, because these sit inside the fetcher card on the
 *  admin page and cards inside cards made the page hard to read. */
export default function Panel({
  title,
  hint,
  actions,
  children,
  testId,
}: {
  title: string;
  hint?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  testId?: string;
}) {
  return (
    <section
      className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800"
      data-testid={testId}
    >
      <div className="px-4 py-2.5 border-b border-gray-100 dark:border-gray-700 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
          {hint && <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{hint}</p>}
        </div>
        {actions && <div className="shrink-0 flex items-center gap-3">{actions}</div>}
      </div>
      {children}
    </section>
  );
}
